module.exports = __webpack_public_path__ + "img/blingrock.71f71de1.png";